import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { AgencyProvider } from "./contexts/AgencyContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AgencyLoader } from "./components/ui/shared/layout/AgencyLoader";
import { ProtectedRoute } from "./components/ui/shared/layout/ProtectedRoute";
import { PermissionRoute } from "./components/ui/shared/layout/PermissionRoute";
import { PublicLayout } from "./components/ui/shared/layout/PublicLayout";
import { AuthenticatedLayout } from "./components/ui/shared/layout/AuthenticatedLayout";
import { AuthenticatedRoutes } from "./data/LeftNavigation";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangeUser from "./pages/ChangeUser";
import Privacy from "./pages/Privacy";

// Route configuration

function App() {
  const [isLeftNavCollapsed, setIsLeftNavCollapsed] = useState(false);

  const toggleLeftNav = () => {
    setIsLeftNavCollapsed((prev) => !prev);
  };

  return (
    <AgencyProvider>
      <AgencyLoader>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route
                path="/login"
                element={
                  <PublicLayout pageTitle="Login">
                    <Login />
                  </PublicLayout>
                }
              />

              <Route
                path="/forgot-password"
                element={
                  <PublicLayout pageTitle="Recuperar Senha">
                    <ForgotPassword />
                  </PublicLayout>
                }
              />

              <Route
                path="/reset-password"
                element={
                  <PublicLayout pageTitle="Redefinir Senha">
                    <ResetPassword />
                  </PublicLayout>
                }
              />

              <Route
                path="/privacy"
                element={
                  <PublicLayout pageTitle="Privacidade">
                    <Privacy />
                  </PublicLayout>
                }
              />

              <Route
                path="/change-user"
                element={
                  <ProtectedRoute>
                    <ChangeUser />
                  </ProtectedRoute>
                }
              />

              {AuthenticatedRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ProtectedRoute>
                      <AuthenticatedLayout
                        isLeftNavCollapsed={isLeftNavCollapsed}
                        toggleLeftNav={toggleLeftNav}
                        pageTitle={route.title}
                      >
                        {route.permission ? (
                          <PermissionRoute requiredPermission={route.permission}>
                            {route.element}
                          </PermissionRoute>
                        ) : (
                          route.element
                        )}
                      </AuthenticatedLayout>
                    </ProtectedRoute>
                  }
                />
              ))}
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AgencyLoader>
    </AgencyProvider>
  );
}

export default App;
